import { inject } from '@angular/core';
import { RedirectFunction } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { defaultRouteFor } from '../helpers/user-roles';

/**
 * Redirección para rutas desconocidas: sin sesión al login; con sesión a la
 * ruta de inicio según rol (admins → /menu, resto → /fichaje).
 */
export const defaultRouteRedirect: RedirectFunction = () => {
  const authService = inject(AuthService);
  return authService.isAuthenticated()
    ? defaultRouteFor(authService.userLogged$())
    : '/auth/login';
};
